/**
 * Voucher QR URL builder — untuk auto-login MikroTik hotspot.
 *
 * Ketika QR di-scan pakai kamera HP native, browser terbuka ke URL ini →
 * MikroTik hotspot intercept → tampilkan login page (form 'username' & 'password'
 * auto-terisi dari GET query) → user tap 'Login' 1x → connect.
 *
 * === MENGAPA PAKAI IP, BUKAN DOMAIN? ===
 * Browser modern (Chrome 83+, iOS 14+ Safari) DEFAULT pakai DNS-over-HTTPS
 * ke Cloudflare/Google → BYPASS DNS-hijack MikroTik → domain internal seperti
 * 'kumarahotspot.net' tidak resolve → user dapat NXDOMAIN.
 * Pakai IP gateway langsung = ZERO DNS dependency = paling reliable.
 *
 * === PORT :80 EXPLICIT ===
 * Explicit port :80 mencegah Chrome 'HTTPS-First' mode meng-upgrade ke HTTPS.
 * MikroTik hotspot hanya listen HTTP; upgrade paksa akan gagal ERR_CONNECTION_ABORTED.
 *
 * === MULTI-MIKROTIK ===
 * Gateway IP di-set per-MikroTik di kolom 'mikrotiks.hotspot_gateway_ip'.
 * Dipilih user via dropdown 'MikroTik Sumber' di modal print voucher.
 * Nilai default '10.5.50.1' hanya fallback bila caller tidak pass explicit IP.
 */

export const HOTSPOT_GATEWAY_IP_DEFAULT = '10.5.50.1';

/**
 * Bangun URL auto-login untuk QR voucher hotspot.
 * @param {string} username - RADIUS username (a.k.a. voucher code)
 * @param {string} password - RADIUS password
 * @param {string} [gatewayIp] - Optional. IP gateway MikroTik hotspot sumber voucher.
 *                              Kalau undefined/empty, fallback ke HOTSPOT_GATEWAY_IP_DEFAULT.
 * @returns {string} URL absolute untuk di-encode ke QR
 */
export function buildHotspotLoginUrl(username, password, gatewayIp) {
  const u = encodeURIComponent(String(username || '').trim());
  const p = encodeURIComponent(String(password || '').trim());
  const ip = String(gatewayIp || '').trim() || HOTSPOT_GATEWAY_IP_DEFAULT;
  // Kalau IP sudah punya port explicit (misal '10.5.50.1:8080'), pakai apa adanya.
  // Kalau tidak, auto-append ':80' untuk mencegah Chrome HTTPS-First upgrade.
  const hostWithPort = ip.includes(':') ? ip : `${ip}:80`;
  return `http://${hostWithPort}/login?username=${u}&password=${p}&dst=/`;
}
